import DatePicker from "react-datepicker";
import { ko } from "date-fns/esm/locale";
import DateFunc from '@/lib/lyg/date_func';
import { customHeaderFunc } from '@/pcomponents/common/date_picker/custom_header';
import { CustomInputWrite } from '@/pcomponents/common/date_picker/custom_input';
import strFunc from '@/lib/lyg/string';
import SelectTab from "@/pcomponents/common/crud/write/select_tab";
import CompStuPrescribeDataFunc from "@/pcomponents/common/content/edu/comp_stu_prescribe/func/data_func";

function TopInfoArea(props: any) {
  let myProps = {
    info: {},
    setInfo: (inInfo: any) => { },
    is_write_mode: false,
    ...props
  };
  let info = myProps.info;
  let is_write_mode = myProps.is_write_mode;
  let select_state_arr = CompStuPrescribeDataFunc.select_state_arr;

  const on_change_input = (e: any) => {
    let { name, value } = e.target;
    let change_info = { ...info, [name]: value };

    if (name == "a_state") {
      if (value == "ready") {
        change_info.a_is_request = "";
      }
      if (value == "ing") {
        if (info.a_is_request != "1") {
          change_info.a_is_request = "1";
          change_info.a_request_date = DateFunc.get_date_format(new Date(), "Y-m-d h:i:s");
        }
      }
      if (value == "complete") {
        if (info.a_is_success != "1") {
          change_info.a_is_success = "1";
          change_info.a_success_date = DateFunc.get_date_format(new Date(), "Y-m-d h:i:s");
        }
      } else {
        change_info.a_is_success = "";
      }
    }

    myProps.setInfo(change_info);
  };
  const onChangeDatePicker = (key: string, date: Date) => {
    let date_str = DateFunc.get_date_format(date, "Y-m-d");
    myProps.set_info({
      ...info,
      ...{ [key]: date_str }
    });
  };

  return (
    <div className="write-table-div">
      <table>
        <colgroup>
          <col width={"20%"}></col>
          <col width={"30%"}></col>
          <col width={"20%"}></col>
          <col width={"30%"}></col>
        </colgroup>
        <tbody>
          <tr>
            <th>제목</th>
            <td colSpan={3}>
              {is_write_mode ?
                <input type="text" name="a_title" value={info.a_title}
                  onChange={on_change_input} autoComplete="off" />
                :
                <span>{info.a_title}</span>
              }
            </td>
          </tr>
          <tr>
            <th>학원명</th>
            <td>
              {is_write_mode ?
                <input type="text" name="a_mcomp_name" value={info.a_mcomp_name}
                  onChange={on_change_input} autoComplete="off" />
                :
                <span>{info.a_mcomp_name}</span>
              }
            </td>
            <th>학생명</th>
            <td>
              {is_write_mode ?
                <span>
                  <input type="text" name="a_stu_name" value={info.a_stu_name}
                    onChange={on_change_input} autoComplete="off"
                    style={{ width: "100px" }} />
                  <span className="ml-1">학년:</span>
                  <input type="text" name="a_stu_grade_str" value={info.a_stu_grade_str}
                    className="ml-1"
                    onChange={on_change_input} autoComplete="off"
                    style={{ width: "60px" }} />
                </span>
                :
                <span>{info.a_stu_name} {info.a_stu_grade_str}</span>
              }
            </td>
          </tr>
          <tr>
            <th>작성자</th>
            <td>
              {is_write_mode ?
                <input type="text" name="a_writer" value={info.a_writer}
                  onChange={on_change_input} autoComplete="off" />
                :
                <span>{info.a_writer}</span>
              }
            </td>
            <th>처방자</th>
            <td>
              {is_write_mode ?
                <input type="text" name="a_prescriber" value={info.a_prescriber}
                  onChange={on_change_input} autoComplete="off" />
                :
                <span>{info.a_prescriber}</span>
              }
            </td>
          </tr>
          <tr>
            <th>상태</th>
            <td colSpan={3}>
              <SelectTab
                select_arr={select_state_arr}
                value={info.a_state}
                is_same_value_empty={false}
                on_select={(value: string) => {
                  if (is_write_mode) {
                    on_change_input({
                      target: { name: "a_state", value: value }
                    });
                  }
                }}
              ></SelectTab>
            </td>
          </tr>
          <tr>
            <th>작성일</th>
            <td>
              {is_write_mode == false ?
                info.a_date
                :
                <div style={{ display: "inline-block", width: 100 }} title={"작성일"}>
                  <DatePicker
                    selected={info.a_date != "" ? new Date(info.a_date) : null}
                    onChange={(date: Date) => {
                      onChangeDatePicker("a_date", date);
                    }}
                    locale={ko}
                    dateFormat="yyyy-MM-dd"
                    customInput={<CustomInputWrite />}
                    renderCustomHeader={customHeaderFunc}
                  />
                </div>
              }
            </td>
            <th>완료일</th>
            <td>
              {info.a_state == "complete" &&
                <span>
                  {info.a_success_date}
                </span>
              }
            </td>
          </tr>
          <tr>
            <th>검사내용</th>
            <td colSpan={3}>
              {is_write_mode ?
                <input type="text" name="a_check_content" value={info.a_check_content}
                  onChange={on_change_input} autoComplete="off" style={{width:"50%"}}/>
                :
                <span>{info.a_check_content}</span>
              }
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
export default TopInfoArea;